import { render } from "./AddressRegistrationForm.vue?vue&type=template&id=052289d3"
import script from "./AddressRegistrationForm.vue?vue&type=script&lang=js"
export * from "./AddressRegistrationForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__